import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { ScheduleService } from 'services/ScheduleService';
import { ShiftProfileCreate } from 'repository/schedule/@types/ShiftProfile';
import { FormShiftProfile } from './FormShiftProfile';
import { ShiftProfileFormValues } from 'schemas/ShiftProfile';

interface CreateProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    rows: any;
    reloading: () => void;
}

const scheduleService = new ScheduleService();

export const CreateShiftProfile: FC<CreateProps> = ({ open, setOpen, rows, reloading }) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const handleSubmit = async (values: ShiftProfileFormValues) => {
        const payload: ShiftProfileCreate = {
            shift_profile_name: values.name,
            shift_profile_description: values.description || '',
            is_night: values.is_night,
            min_start_time: values.start_time_min,
            max_start_time: values.start_time_max,
            min_end_time: values.end_time_min,
            max_end_time: values.end_time_max,
            standard_duration: values.duration_standard,
            min_duration: values.duration_min,
            max_duration: values.duration_max,
        };

        try {
            await scheduleService.shift_profile.create(payload);
            enqueueSnackbar('Perfil de turno creado', { variant: 'success' });
            reloading();
        } catch (error) {
            console.error(error);
            enqueueSnackbar(t('general.errors.unexpected'), { variant: 'error' });
            throw error;
        }
    };

    return (
        <FormShiftProfile
            open={open}
            setOpen={setOpen}
            rows={rows}
            titleKey={'Nuevo perfil de turno'}
            onSubmit={handleSubmit}
        />
    );
};
